<script>
import NotificationBell from 'vue-notification-bell';
import { pickupRequestMethods, clientMethods } from '@state/helpers'
import { XERO_AUTH_ENDPOINT } from '../endpoints';

export default {
  name: 'YourComponentName',
  components: {
    NotificationBell // Registering Component
  },
  props: {
    menuToggle: {
      type: Boolean,
      required: true,
    },
    notification:{
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      navWidth: 280,
      menuStatus: false,
      paddingExist: false,
      clientRequestsExist: false,
      clientRequests:[]
    }
  },
  watch: {
    menuToggle: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.navWidth = 280
        this.menuStatus = newVal
      } else {
        this.navWidth = 0
        this.menuStatus = false;
        // this.calcNavWidth()
      }
    },
    'notification'() {
      this.getDataNotification();
    }
  },
  mounted() {
    this.getDataNotification();
    // this.calcNavWidth()
    if(window.innerWidth < 980)
      this.navWidth = 0

    let that = this
    window.addEventListener('resize', function() {
      this.menuStatus = false;
      if(this.menuStatus){
        that.calcNavWidth()
      }else if(!this.menuStatus && window.innerWidth < 980){
        this.navWidth = 0
      }
      // else if(window.innerWidth > 980){
      //   that.calcNavWidth()
      // }
    })
  },
  methods: {
    ...pickupRequestMethods,...clientMethods,
    click() {
      return true
    },
    async getDataNotification(){
      // Check if has to notify the Admin
      await this.getPickupRequests().then(response=>{
        let obj = this.$store.state.pickuprequest.pickuprequest
        // console.log("result:",obj[1].status)
        for(let v in obj){
          // this.pickuprequests.push(obj[v]);
          // console.log(obj[v].status);
          if(obj[v].status.trim() === "PENDING")
          {
            this.paddingExist = true;
            // console.log(this.paddingExist)
          }
        }

        // check if client has a request or not
        this.getClientRequests().then(res=>{
          // let reqObj = this.$store.state.clients.requestobjects
          // // console.log(reqObj);
          // for(var v in reqObj){
          //    this.clientRequests.push(reqObj[v]);
          //    console.log(reqObj[v]);
          // }
          if(res.length > 0){
            this.clientRequestsExist = true;
            // console.log(this.clientRequestsExist);
          }
        });
      });
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    xeroAuth() {
      window.location.replace(XERO_AUTH_ENDPOINT)
    },
    calcNavWidth() {
      // console.log(this.menuStatus)
      if (window.innerWidth < 980) {
        this.navWidth = 0
      } else if (!this.menuStatus && window.innerWidth < 980){
        this.navWidth = 0
      } else if (window.innerWidth > 980){
        this.navWidth = 280
      }
    },
    isCurrentRoute(routeName) {
      return this.$route.name === routeName
    },
    isCollectionRoute() {
      return this.routeNameContains('collection')
    },
    isGeneralManagementRoute() {
      let routes = [
        'depots',
        'view-depot',
        'routes',
        'view-route',
        'service-charges',
        'tips',
        'vehicles',
        'view-vehicle',
        'view-tyrelog',
        'view-truck-service',
        'equipment',
        'bins-to-be-completed',
        'admin-charge-types',
        'admin-service-types',
        'waste-types',
        'messages',
        'manage-users',
        'view-user',
      ]
      return routes.indexOf(this.$route.name) > -1
    },
    isReportsRoute() {
      let routes = [
        'admininvoices',
        'client-reports',
        'view-client-reports',
        'all-clients-reports',
        'vehicle-reports',
        'waste-reports',
        'run-sheet-report',
        'services-collected-report',
      ]
      return routes.indexOf(this.$route.name) > -1
    },
    routeNameContains(routeNamePart) {
      return this.$route.name.indexOf(routeNamePart) > -1
    },
    routeActiveClass(routeName) {
      if (this.isCurrentRoute(routeName)) {
        return "active"
      }
      return ""
    },
    routeInActiveClass(routeNames) {
      if (routeNames.indexOf(this.$route.name) > -1) {
        return "active"
      }
      return ""
    }
  }
}
</script>

<template>
  <VNavigationDrawer
    stateless
    dark
    value="true"
    :width="navWidth"
    :menu-props="{ absolute: true }"
    temporary
    hide-overlay
  >
    <img
      src="../assets/images/power-logo.png"
      alt="power waste logo"
      :class="$style.navLogo"
    >
    <VList>
      <VListTile
        @click="changeRoute('/admin/')"
      >
        <VListTileTitle :class="routeActiveClass('dashboard')">
          <span :class="$style.navTitle">
            Dashboard
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/map/')"
      >
        <VListTileTitle :class="routeActiveClass('map')">
          <span :class="$style.navTitle">
            Map
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/admin/client-center')"
      >
        <VListTileTitle :class="routeInActiveClass(['client-center', 'view-client', 'view-site', 'view-service'])">
          <span :class="$style.navTitle">
            Client Center
            <div
              v-if="clientRequestsExist"
              :class="$style.notificationIcon"
              style="margin-left: 106px;"
            >
              <NotificationBell
                :size="14"
                icon-color="#ffffff"
              />
            </div>
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/admin/driver-center')"
      >
        <VListTileTitle :class="routeActiveClass('driver-center')">
          <span :class="$style.navTitle">
            Driver Center
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/admin/run-sheets')"
      >
        <VListTileTitle :class="routeActiveClass('run-sheets')">
          <span :class="$style.navTitle">
            Run Sheets
          </span>
        </VListTileTitle>
      </VListTile>

      <VListGroup :value="isCollectionRoute()">
        <VListTile
          slot="activator"
        >
          <VListTileTitle>
            <span :class="$style.navTitle">
              Collections
              <div
                v-if="paddingExist"
                :class="$style.notificationIcon"
              >
                <NotificationBell
                  :size="14"
                  icon-color="#ffffff"
                />
              </div>
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/all-collections')"
        >
          <VListTileTitle :class="routeInActiveClass(['all-collections', 'view-collection-notes-photos'])">
            <span :class="$style.navTitle">
              All Collections
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/incomplete-collections')"
        >
          <VListTileTitle :class="routeActiveClass('incomplete-collections')">
            <span :class="$style.navTitle">
              Incomplete Collections
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/reassign-collections')"
        >
          <VListTileTitle :class="routeActiveClass('reassign-collections')">
            <span :class="$style.navTitle">
              Re-assign Collections
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/requested-collections')"
        >
          <VListTileTitle :class="routeActiveClass('requested-collections')">
            <span :class="$style.navTitle">
              Requested Collections
              <div
                v-if="paddingExist"
                :class="$style.notificationIcon"
              >
                <NotificationBell
                  :size="14"
                  icon-color="#ffffff"
                />
              </div>
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/unassigned-collections')"
        >
          <VListTileTitle :class="routeActiveClass('unassigned-collections')">
            <span :class="$style.navTitle">
              Unassigned Collections
            </span>
          </VListTileTitle>
        </VListTile>

      </VListGroup>

      <VListGroup :value="isGeneralManagementRoute()">
        <VListTile
          slot="activator"
        >
          <VListTileTitle>
            <span :class="$style.navTitle">
              General Management
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/routes')"
        >
          <VListTileTitle :class="routeInActiveClass(['routes', 'view-route'])">
            <span :class="$style.navSubtitle">
              Routes
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/depots')"
        >
          <VListTileTitle :class="routeInActiveClass(['depots', 'view-depot'])">
            <span :class="$style.navSubtitle">
              Depots
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/service-charges')"
        >
          <VListTileTitle :class="routeActiveClass('service-charges')">
            <span :class="$style.navSubtitle">
              Extra Service Charges
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/tips')"
        >
          <VListTileTitle :class="routeActiveClass('tips')">
            <span :class="$style.navSubtitle">
              Tip Locations
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/vehicles')"
        >
          <VListTileTitle :class="routeInActiveClass(['vehicles', 'view-vehicle', 'view-tyrelog', 'view-truck-service'])">
            <span :class="$style.navSubtitle">
              Vehicle Management
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/equipment')"
        >
          <VListTileTitle :class="routeActiveClass('equipment')">
            <span :class="$style.navSubtitle">
              Equipment Management
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/bins-to-be-completed')"
        >
          <VListTileTitle :class="routeActiveClass('bins-to-be-completed')">
            <span :class="$style.navSubtitle">
              Bins to be Completed
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/charge-types')"
        >
          <VListTileTitle :class="routeActiveClass('admin-charge-types')">
            <span :class="$style.navSubtitle">
              Charge Types
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/service-types')"
        >
          <VListTileTitle :class="routeActiveClass('admin-service-types')">
            <span :class="$style.navSubtitle">
              Service Types
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/waste-types')"
        >
          <VListTileTitle :class="routeActiveClass('waste-types')">
            <span :class="$style.navSubtitle">
              Waste Types
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/messages')"
        >
          <VListTileTitle :class="routeActiveClass('messages')">
            <span :class="$style.navSubtitle">
              Messages
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          v-if="this.$store.getters['auth/getUserRole'] === 'Admin'"
          @click="changeRoute('/admin/manage-users')"
        >
          <VListTileTitle :class="routeInActiveClass(['manage-users', 'view-user'])">
            <span :class="$style.navSubtitle">
              Manage Users
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          v-if="this.$store.getters['auth/getUserRole'] === 'Admin'"
          @click="xeroAuth()"
        >
          <VListTileTitle>
            <span :class="$style.navSubtitle">
              Authorize Xero
            </span>
          </VListTileTitle>
        </VListTile>

      </VListGroup>

      <VListGroup :value="isReportsRoute()">
        <VListTile
          slot="activator"
        >
          <VListTileTitle>
            <span :class="$style.navTitle">
              Reports
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/run-sheet-report')"
        >
          <VListTileTitle :class="routeActiveClass('run-sheet-report')">
            <span :class="$style.navSubtitle">
              Run Sheet Report
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/services-collected-report')"
        >
          <VListTileTitle :class="routeActiveClass('services-collected-report')">
            <span :class="$style.navSubtitle">
              Services Collected Report
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/invoices')"
        >
          <VListTileTitle :class="routeActiveClass('admininvoices')">
            <span :class="$style.navSubtitle">
              Client Invoices
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/client-reports')"
        >
          <VListTileTitle :class="routeInActiveClass(['client-reports', 'view-client-reports'])">
            <span :class="$style.navSubtitle">
              Client Reports
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/all-clients-reports')"
        >
          <VListTileTitle :class="routeActiveClass('all-clients-reports')">
            <span :class="$style.navSubtitle">
              All Clients Reports
            </span>
          </VListTileTitle>
        </VListTile>
        
        <!--  These reports do nothing...
        
        <VListTile
          @click="changeRoute('/admin/vehicle-reports')"
        >
          <VListTileTitle :class="routeActiveClass('vehicle-reports')">
            <span :class="$style.navSubtitle">
              Vehicle Reports
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="changeRoute('/admin/waste-reports')"
        >
          <VListTileTitle :class="routeActiveClass('waste-reports')">
            <span :class="$style.navSubtitle">
              Waste Reports
            </span>
          </VListTileTitle>
        </VListTile>
        -->

        <!--<VListTile-->
        <!--@click="changeRoute('/vehicles')"-->
        <!--&gt;-->
        <!--<VListTileTitle>-->
        <!--<span :class="$style.navSubtitle">-->
        <!--Job Notes & Photos-->
        <!--</span>-->
        <!--</VListTileTitle>-->
        <!--</VListTile>-->

        <!--<VListTile-->
        <!--@click="changeRoute('/vehicles')"-->
        <!--&gt;-->
        <!--<VListTileTitle>-->
        <!--<span :class="$style.navSubtitle">-->
        <!--Tipping Logs-->
        <!--</span>-->
        <!--</VListTileTitle>-->
        <!--</VListTile>-->

      </VListGroup>

      <VListTile
        @click="changeRoute('/logout')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            Logout
          </span>
        </VListTileTitle>
      </VListTile>

      <!-- <VListGroup>
        <VListTile
          slot="activator"
        >
          <VListTileTitle>
            <span :class="$style.navTitle">
              Settings & Policies
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="click"
        >
          <VListTileTitle>
            <span :class="$style.navSubtitle">
              Overages Listing
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="click"
        >
          <VListTileTitle>
            <span :class="$style.navSubtitle">
              Weight Pricing Policy
            </span>
          </VListTileTitle>
        </VListTile>

        <VListTile
          @click="click"
        >
          <VListTileTitle>
            <span :class="$style.navSubtitle">
              Vehicles Listing
            </span>
          </VListTileTitle>
        </VListTile>
      </VListGroup> -->

    </VList>
  </VNavigationDrawer>
</template>

<style lang="scss" module>
@import '@design';

.navLogo {
  display: block;
  width: 50%;
  padding-top: 40px;
  padding-bottom: 40px;
  margin: 0 auto;
}

.notificationIcon{
  display: inline-block;
  vertical-align: baseline;
  margin-left: 37px;
}

.navTitle {
  padding-left: 20px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 15px;
  min-height: 30px;
}

.navSubtitle {
  padding-left: 30px;
}
</style>
